import { formatHtml } from "@trumpf/ux.common-storybook";
import { IconTeaserTemplate, iconTeaserData } from "./icon.templates";

export default {
    title: "Website/Partial Templates/Teaser/Icon",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    render: IconTeaserTemplate.bind({}),
    args: { ...iconTeaserData },
};

export const Default = {};

export const ServiceIcon = {
    args: {
        variant: "service-icon",
    },
};
